import React, { ReactNode } from "react";
import { Box } from "@mui/system";
import { Paper } from "@mui/material";
import { Plan } from "../constants";
import { Check } from "@mui/icons-material";

export function DetailCard({
  title,
  description,
  isFree,
  selectedPlan,
}: {
  title: ReactNode;
  description: ReactNode;
  isFree: boolean;
  selectedPlan: Plan;
}) {
  return (
    <Paper
      className="detail-card"
      sx={{
        position: "relative",
        display: "grid",
        gridTemplateRows: "auto auto 1fr",
        textJustify: "inter-word",
        padding: "3ch 3ch 1ch",
        border: "1px solid rgb(90% 90% 90%)",
      }}
      elevation={0}
    >
      <Box className="detail-card-title" sx={{ marginBottom: "1ch" }}>
        {title}
      </Box>
      <Box className="detail-card-description" sx={{ marginBottom: "1rem" }}>
        {description}
      </Box>
      <Box
        sx={{
          placeSelf: "end stretch",
          display: "grid",
          fontSize: "0.8rem",
        }}
      >
        <Box
          sx={{
            placeSelf: "end stretch",
            gridRow: "1 / 1",
            gridColumn: "1 / 1",
            display: "flex",
            justifyContent: "start",
            color: "rgb(50% 50% 50%)",
            fontSize: "0.8rem",
            marginBottom: "0.5em",
          }}
        >
          {isFree ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingRight: "1ch",
                marginRight: "1ch",
              }}
            >
              Developer{" "}
              <Check
                sx={{
                  color:
                    selectedPlan.id == "free"
                      ? "brand.green.main"
                      : "text.secondary",
                  fontSize: "1em",
                }}
              />
            </Box>
          ) : null}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            Team{" "}
            <Check
              sx={{
                color:
                  selectedPlan.id == "on_demand"
                    ? "brand.green.main"
                    : "text.secondary",
                fontSize: "1em",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
